
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes bootstrap and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('../../../node_modules/babel-polyfill');
require('./bootstrap');
require('../../../node_modules/bootstrap-colorpicker/dist/js/bootstrap-colorpicker.min');
require('../../../node_modules/moment/moment');
require('./bootstrap-datetimepicker.js');
require('../../../node_modules/chart.js/dist/Chart');
require('../../../node_modules/chart.js/dist/Chart.min');
require('../../../resources/assets/js/jquery.jqplot/excanvas');
require('../../../resources/assets/js/jquery.jqplot/jquery.jqplot');
require('../../../resources/assets/js/jquery.jqplot/plugins/jqplot.pieRenderer');
require('../../../resources/assets/js/jquery.jqplot/plugins/jqplot.highlighter');
require('../../../node_modules/bootstrap-select/dist/js/bootstrap-select.min');
require('../../../node_modules/jquery-bootstrap-scrolling-tabs/dist/jquery.scrolling-tabs.min');
require('../../../node_modules/bootstrap-vue');
require('./dropzone');
require('./moment.min');
require('./used_on_multiple_pages');
require('./scripts/togglepwd.js');
require('../../../node_modules/@fancyapps/fancybox/dist/jquery.fancybox.min');
require('../../../resources/assets/js/apexcharts/dist/apexcharts.min');

require('../../../resources/assets/js/ssoLogin');
require('./notification'); // notification for ajax response
require('./datatables-config');
require('./icons');
require('./logging.js'); // catch console.error and warning and do some action
require('./language_switcher.js');
require('./backButtonHrefSetter.js');
require('./scripts/global_general.js');
require('./dateStringToTimestamp.js');
require('../../../public/js/general/xlsx.min');
/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from "laravel-echo"
import ApexCharts from "./apexcharts/dist/apexcharts.min.js"

if (window.global_vars != undefined && window.global_vars.env.WEBSOCKETS_ENABLED) {

    window.ApexCharts           = ApexCharts;

    window.Pusher = require('../../../node_modules/pusher-js');

    window.Pusher.logToConsole = true;

    // Handle different production configuration
    if(window.global_vars.env.APP_ENV === 'production'){
        window.websocketsConfiguration = {
            broadcaster         : 'pusher',
            key                 : window.global_vars.env.MIX_PUSHER_APP_KEY,
            wsHost              : window.location.hostname,
            forceTLS            : false,
            disableStats        : true,
            encrypted           : false,
            enabledTransports   : ['ws', 'wss']
        }
    }else{
        window.websocketsConfiguration = {
            broadcaster         : 'pusher',
            key                 : window.global_vars.env.MIX_PUSHER_APP_KEY,
            wsHost              : window.location.hostname,
            wsPort              : 6001,
            wssPort             : 6001,
            forceTLS            : false,
            disableStats        : true,
            encrypted           : false,
            enabledTransports   : ['ws', 'wss']
        }
    }

    window.Echo = new Echo(window.websocketsConfiguration);

}

$(document).ready(function(){
    $('#nav-icon').click(function(){
        $(this).toggleClass('open');
        $('#sidebar').toggleClass('opened');
        $('.scrtabs-tab-container').toggleClass('groupsMobile');
    });

});
import Cropper from 'cropperjs';

window.cropper = Cropper;
import Vue from 'vue';
window.Vue = require('vue');

// Load xlsx library
var XLSX = require("xlsx");
window.XLSX=XLSX;

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.component('tabs', require('./components/tabs.vue'));
Vue.component('upload', require('./components/upload.vue'));
Vue.component('document-template-form', require('../../js/vendor/document-templates/components/DocumentTemplateFormComponent.vue'));
Vue.component('loader', require('./components/loader.vue'));
Vue.component('statistics-button', require('./components/statisticsbutton.vue'));
Vue.component('documentsstatistics', require('./components/documentsstatistics.vue'));
Vue.component('deleteconfirmation', require('./components/deleteconfirmation.vue'));
Vue.component('filters', require('./components/filters.vue'));
Vue.prototype.trans = (key) => {
  return _.get(window.trans, key, key);
};


// WEBPACK FOOTER //
// ./resources/assets/js/app.js